function isObject(data) {
    return typeof data === "object" && data !== null;
  }

  const walletMetadata = {
    get() {
      try {
        const wallet_metadata = JSON.parse(
          localStorage.getItem("wallet_metadata")
        );
        if (!isObject(wallet_metadata)) {
          return {
            id:       0,
            email:    "",
            enabled:  false,
            verified: false,
          }
        }

        return {
          id:       wallet_metadata.id,
          email:    wallet_metadata.email,
          enabled:  wallet_metadata.enabled === 1,
          verified: wallet_metadata.verified === 1,
        };
      } catch (err) {
        return {
          id:       0,
          email:    "",
          enabled:  false,
          verified: false,
        };
      }
    },
  };

  export default walletMetadata;
